





export type IPropertyPair = [string, string];


const PropertyTable:React.FC<{properties:Record<string, string>}> = (props) => {

    const table = props.properties;
    return <table>
        <tr>
            <th>Property</th>
            <th>Value</th>
        </tr>
        { Object.keys(table).map(key => <tr key={key}>
            <td>{key}</td>
            <td>{table[key]}</td>
        </tr>)}
    </table>
}
export default PropertyTable;